module.exports = __webpack_public_path__ + "static/media/android.6b5c2c6a.svg";